import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import useCancelUploadDialog from '../../hooks/useCancelUploadDialog';

export type CancelDataUploadButtonProps = {
  bulkImportId: string;
  children: string;
  className?: string;
  ['data-testid']?: string;
  disabled?: boolean;
  icon?: boolean;
};

export default function CancelDataUploadButton({
  bulkImportId,
  children,
  className = '',
  'data-testid': dataTestid = '',
  disabled = false,
  icon = false,
}: CancelDataUploadButtonProps) {
  const showCancelUploadDialog = useCancelUploadDialog();

  const handleClick = React.useCallback(() => {
    showCancelUploadDialog(bulkImportId);
  }, [bulkImportId, showCancelUploadDialog]);

  return icon ? (
    <IconButton
      aria-label={children}
      color="primary"
      onClick={handleClick}
      className={className}
      data-testid={dataTestid}
      disabled={disabled}
    >
      <DeleteIcon />
    </IconButton>
  ) : (
    <Button
      onClick={handleClick}
      className={className}
      data-testid={dataTestid}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
